import React, { useContext, useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axiosIntance from '../../../config/axios'
import { RootContext } from '../../../App';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import { Card, CardBody, CardHeader } from "@material-tailwind/react";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Link } from 'react-router-dom'
import Swal from "sweetalert2";

const EditAdminRole = () => {

    const [data , setData] = useState([])
    const [pending , setPending] = useState(true)
    const token = localStorage.getItem("access_token")
    const group = JSON.parse(localStorage.getItem("group"))
    const {state , setState} = useContext(RootContext)
    const param = useParams();

    function handleDeleteMenu(menuid) {
        
        axiosIntance.post('delete_role_menu' , {
        token :token ,
        group :group.wbid,
        roleid: param.roleid,
        menuid: menuid
        }).then((res)=>{

            if(res.data.code === 0){

                Swal.fire("Success", 'Role Menu Are Deleted', 'success').then(() => {

                    setPending(false)
                    setData(res.data.data.list)
                    setState({
                        ...state,
                        group: res.data.data.additional_data.group,
                        menu: refactorStructureData(res.data.data.additional_data.menu),
                    })
                })
            }else{

                Swal.fire("Error", 'Internal Server Error', 'error').then(() => {

                    setPending(false)
                })
            }
        })
    }

    useEffect(()=>{

        axiosIntance.post('get_role_menu' , {
        token :token ,
        group :group.wbid,
        roleid: param.roleid
        }).then((res)=>{

            setPending(false)
            setData(res.data.data.list)
            setState({
                ...state,
                group: res.data.data.additional_data.group,
                menu: refactorStructureData(res.data.data.additional_data.menu),
            })
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

    const columns = [
        {
            name: "Menu Root",
            selector: (row) => row.get_menu.menu_root ? row.get_menu.menu_root : "Not Found",
            sortable: false,
        },
        {
            name: "Menu Name",
            selector: (row) => row.get_menu.menu_name ? row.get_menu.menu_name : "Not Found",
            sortable: false,
        },
        {
            name: "Description",
            selector: (row) => {
                let desc = row.description ? row.description : ""
                return desc;
            },
            sortable: false,
        },
        {
            name: "Delete Menu",
            selector: (row) => {

                return <button className='w-14 h-7 bg-red-500 rounded-md text-white' onClick={() => {

                    setPending(true)
                    handleDeleteMenu(row.get_menu.mn_id)
                }}>Delete</button>
            },
            sortable: false,
        },
        
    ]

  return (
    <Card>
        <CardHeader color="blueGray" contentPosition="left">
            <h2 className="text-white text-2xl">Role Menu</h2>
        </CardHeader>
        <Link to={"/admin/role/add/" + param.roleid}>
            <button className='h-[55px] bg-[#04A9F4] p-4 rounded-lg ml-4 text-white'>
                Add New Menu
            </button>
        </Link>
        <CardBody >
            <div className='w-full h-auto border-2 border-gray-800 border-solid rounded-md flex flex-col'>
                <div className='w-full h-20 bg-gray-600 px-10 flex items-center'>
                    <div className='text-[24px] text-white'>
                        Menu List
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={pending}
                />
            </div>
        </CardBody>
    </Card>
  )
}

export default EditAdminRole